import { MetaData } from '../../models';
import { RouteKeys } from './route-keys';

export const metaData: MetaData = {
  title: 'ReportedUsers',
  resource: 'user/reported-users',
  source: 'data.data',
  route: RouteKeys.List,
  paginate: true,
  perPage: 10,
  page: 1,
  defaultSortField: 'title',
};
